var map = {
	"./green_dollar.svg": "b73a",
	"./hand_click.svg": "9ab0",
	"./hologram-map-2.svg": "d9d7",
	"./hologram-map-background-yellow.svg": "4a77",
	"./hologram-map-background.svg": "bd94",
	"./hologram-map.svg": "4d71",
	"./icons/edit.svg": "daf0",
	"./icons/fa-question.svg": "7697",
	"./icons/grupo.svg": "3dc9",
	"./icons/grupo2.svg": "d7d4",
	"./icons/profilecard.svg": "896b",
	"./icons/telegram_logo.svg": "a91d",
	"./icons/teleoperador.svg": "03a1",
	"./pointer.svg": "9ed6",
	"./roulette_card_images/EcoCard.svg": "68f8",
	"./roulette_card_images/business_sectors/BS00.svg": "4953",
	"./roulette_card_images/business_sectors/BS01.svg": "c76b",
	"./roulette_card_images/business_sectors/BS03.svg": "2395",
	"./roulette_card_images/business_sectors/BS04.svg": "1c66",
	"./roulette_card_images/business_sectors/BS05.svg": "b098",
	"./roulette_card_images/business_sectors/BS06.svg": "ae99",
	"./roulette_card_images/business_sectors/BS07.svg": "5721",
	"./roulette_card_images/business_sectors/BS08.svg": "4e98",
	"./roulette_card_images/business_sectors/BS09.svg": "1189",
	"./roulette_card_images/business_sectors/BS10.svg": "112a",
	"./roulette_card_images/business_sectors/BS11.svg": "8f6c",
	"./roulette_card_images/business_sectors/BS12.svg": "5aa4",
	"./roulette_card_images/business_sectors/BS13.svg": "fb9a",
	"./roulette_card_images/business_sectors/BS14.svg": "aaef",
	"./roulette_card_images/business_sectors/BS15.svg": "9744",
	"./roulette_card_images/business_sectors/BS16.svg": "47fe",
	"./roulette_card_images/business_sectors/BS17.svg": "5a5a",
	"./roulette_card_images/business_sectors/BS18.svg": "59ee",
	"./roulette_card_images/business_sectors/BS19.svg": "22b3",
	"./roulette_card_images/business_sectors/BS20.svg": "4e6c",
	"./roulette_card_images/business_sectors/BS21.svg": "7a05",
	"./roulette_card_images/business_sectors/BS22.svg": "25c7",
	"./roulette_card_images/business_sectors/BS23.svg": "f14b",
	"./roulette_card_images/business_sectors/BS28.svg": "88c4",
	"./roulette_card_images/business_sectors/BS30.svg": "e1b8",
	"./roulette_card_images/business_sectors/BS31.svg": "9969",
	"./roulette_card_images/business_sectors/BS32.svg": "92ad",
	"./roulette_card_images/business_sectors/BS33.svg": "7c5c",
	"./roulette_card_images/business_sectors/BS34.svg": "220c",
	"./roulette_card_images/business_sectors/BS35.svg": "f606",
	"./roulette_card_images/business_sectors/BS37.svg": "f695",
	"./roulette_card_images/business_sectors/BS38.svg": "fad1",
	"./roulette_card_images/business_sectors/BS39.svg": "98a9",
	"./roulette_card_images/business_sectors/BS40.svg": "fe74",
	"./roulette_card_images/capital_program_types/CPT00.svg": "a722",
	"./roulette_card_images/capital_program_types/CPT01.svg": "d375",
	"./roulette_card_images/capital_program_types/CPT02.svg": "574d",
	"./roulette_card_images/capital_program_types/CPT03.svg": "ef96",
	"./roulette_card_images/capital_program_types/CPT04.svg": "9a62",
	"./roulette_card_images/ebidta_amount_ranges/icon.svg": "4209",
	"./roulette_card_images/ebidta_sign/FQES00.svg": "5128",
	"./roulette_card_images/ebidta_sign/FQES01.svg": "3e69",
	"./roulette_card_images/ebidta_sign/FQES02.svg": "72bd",
	"./roulette_card_images/economic_sectors/ES00.svg": "1957",
	"./roulette_card_images/economic_sectors/ES01.svg": "3b40",
	"./roulette_card_images/economic_sectors/ES02.svg": "b6c4",
	"./roulette_card_images/economic_sectors/ES03.svg": "5a34",
	"./roulette_card_images/economic_sectors/ES04.svg": "601d",
	"./roulette_card_images/economic_sectors/ES05.svg": "fa88",
	"./roulette_card_images/fundraising_program_types/FPT00.svg": "ead8",
	"./roulette_card_images/fundraising_program_types/FPT01.svg": "eb6a",
	"./roulette_card_images/fundraising_program_types/FPT02.svg": "edf7",
	"./roulette_card_images/fundraising_program_types/FPT03.svg": "f436",
	"./roulette_card_images/fundraising_program_types/FPT04.svg": "34f6",
	"./roulette_card_images/fundraising_program_types/FPT05.svg": "e621",
	"./roulette_card_images/fundraising_program_types/FPT06.svg": "26ef",
	"./roulette_card_images/fundraising_program_types/FPT07.svg": "4abe",
	"./roulette_card_images/fundraising_program_types/FPT08.svg": "050a",
	"./roulette_card_images/fundraising_program_types/FPT09.svg": "95aa",
	"./roulette_card_images/fundraising_program_types/FPT10.svg": "0932",
	"./roulette_card_images/fundraising_program_types/FPT11.svg": "b4da",
	"./roulette_card_images/fundraising_program_types/FPT12.svg": "edcf",
	"./roulette_card_images/fundraising_program_types/FPT13.svg": "587a",
	"./roulette_card_images/fundraising_program_types/FPT14.svg": "ba60",
	"./roulette_card_images/fundraising_program_types/FPT15.svg": "6463",
	"./roulette_card_images/fundraising_program_types/FPT16.svg": "9243",
	"./roulette_card_images/fundraising_program_types/FPT17.svg": "22b30",
	"./roulette_card_images/fundraising_program_types/FPT18.svg": "d02b",
	"./roulette_card_images/fundraising_program_types/FPT19.svg": "0dfd",
	"./roulette_card_images/fundraising_program_types/FPT20.svg": "adc4",
	"./roulette_card_images/fundraising_program_types/FPT21.svg": "877e",
	"./roulette_card_images/fundraising_program_types/FPT22.svg": "b639b",
	"./roulette_card_images/fundraising_program_types/FPT23.svg": "81bd",
	"./roulette_card_images/fundraising_program_types/FPT24.svg": "b128",
	"./roulette_card_images/fundraising_program_types/FPT25.svg": "28d8",
	"./roulette_card_images/has_account_auditor/icon.svg": "d210",
	"./roulette_card_images/program_beneficiaries/PB00.svg": "9ed5",
	"./roulette_card_images/program_beneficiaries/PB01.svg": "966e",
	"./roulette_card_images/program_currency_types/PCT00.svg": "2e44",
	"./roulette_card_images/program_currency_types/PCT01.svg": "7752",
	"./roulette_card_images/program_currency_types/PCT02.svg": "8097",
	"./roulette_card_images/program_currency_types/PCT03.svg": "a3fd",
	"./roulette_card_images/program_currency_types/PCT04.svg": "74ed",
	"./roulette_card_images/program_currency_types/PCT05.svg": "ccb6",
	"./roulette_card_images/program_currency_types/PCT06.svg": "fd7d",
	"./roulette_card_images/program_currency_types/PCT07.svg": "966a",
	"./roulette_card_images/program_currency_types/PCT08.svg": "5570",
	"./roulette_card_images/program_currency_types/PCT10.svg": "79ee",
	"./roulette_card_images/program_currency_types/PCT11.svg": "1403",
	"./roulette_card_images/program_currency_types/PCT12.svg": "76ff",
	"./roulette_card_images/program_currency_types/PCT13.svg": "244f",
	"./roulette_card_images/program_currency_types/PCT14.svg": "1aeb",
	"./roulette_card_images/program_currency_types/PCT15.svg": "b095",
	"./roulette_card_images/program_currency_types/PCT16.svg": "a935",
	"./roulette_card_images/requested_amount_ranges/icon.svg": "6f85",
	"./roulette_card_images/requester_company_types/RCT00.svg": "3d73",
	"./roulette_card_images/requester_company_types/RCT01.svg": "d102",
	"./roulette_card_images/requester_company_types/RCT02.svg": "00a5",
	"./roulette_card_images/requester_company_types/RCT03.svg": "a952",
	"./roulette_card_images/requester_company_types/RCT04.svg": "9e77",
	"./roulette_card_images/requester_company_types/RCT05.svg": "a63c",
	"./roulette_card_images/requester_company_types/RCT06.svg": "2711",
	"./roulette_card_images/requester_company_types/RCT07.svg": "5e80",
	"./roulette_card_images/requester_company_types/RCT08.svg": "5826",
	"./roulette_card_images/requester_company_types/RCT09.svg": "96f3",
	"./roulette_card_images/requester_company_types/RCT10.svg": "f8e8",
	"./roulette_card_images/requester_company_types/RCT11.svg": "32f0",
	"./roulette_card_images/requester_company_types/RCT12.svg": "bcd0",
	"./roulette_card_images/sells_amount_ranges/icon.svg": "238b",
	"./roulette_card_images/sells_prediction/FQSP00.svg": "89dd",
	"./roulette_card_images/sells_prediction/FQSP01.svg": "c8ed",
	"./roulette_card_images/sells_prediction/FQSP02.svg": "3ce3",
	"./roulette_card_images/sells_prediction/FQSP03.svg": "5b51",
	"./step-signal.svg": "ff0e",
	"./timon_colores.svg": "abcf",
	"./upload-icon.svg": "1e1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";